// extracted by mini-css-extract-plugin
export default {"spotahome-logo":"SpotahomeLogo_spotahome-logo__rAWCm"};